// extracted by mini-css-extract-plugin
export default {"switchContainer":"SwitchContainer_switchContainer__MRbMF","disabled":"SwitchContainer_disabled__28chO","switch":"SwitchContainer_switch__QuNs+"};